import { render, staticRenderFns } from "./GuiasCompraSinTransporteIndex.vue?vue&type=template&id=993c29c6"
import script from "./GuiasCompraSinTransporteIndex.vue?vue&type=script&lang=js"
export * from "./GuiasCompraSinTransporteIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports